import { render, staticRenderFns } from "./thank-you-demo.vue?vue&type=template&id=55444977&scoped=true&"
import script from "./thank-you-demo.vue?vue&type=script&lang=js&"
export * from "./thank-you-demo.vue?vue&type=script&lang=js&"
import style0 from "./thank-you-demo.vue?vue&type=style&index=0&id=55444977&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55444977",
  null
  
)

export default component.exports